// Middleware
import AuthMiddleware from '@middleware/AuthMiddleware';
import SectionMiddleware from '@middleware/SectionMiddleware';

// Layouts
import LayoutApp from '@layouts/LayoutApp';

export default {
    path: '/',
    component: LayoutApp,
    children: [
        {
            path: 'settings',
            name: 'settings',
            component: () => import('@pages/settings'),
            redirect: {
                name: 'settings.project'
            },
            children: [
                {
                    path: 'project',
                    name: 'settings.project',
                    component: () => import('@pages/settings/PageSettingsProject'),
                    meta: {
                        middleware: [AuthMiddleware, SectionMiddleware],
                        title: 'titles.settings',
                    },
                },
                {
                    path: 'domain',
                    name: 'settings.domain',
                    component: () => import('@pages/settings/PageSettingsDomain'),
                    meta: {
                        middleware: [AuthMiddleware, SectionMiddleware],
                        title: ['titles.settings', 'labels.domain'],
                    },
                },
                {
                    path: 'locations',
                    name: 'settings.locations',
                    component: () => import('@pages/settings/PageSettingsLocations'),
                    meta: {
                        middleware: [AuthMiddleware, SectionMiddleware],
                        title: ['titles.settings', 'labels.locations'],
                    },
                },
                {
                    path: 'appearance',
                    name: 'settings.appearance',
                    component: () => import('@pages/settings/PageSettingsAppearance'),
                    meta: {
                        middleware: [AuthMiddleware, SectionMiddleware],
                        title: ['titles.settings', 'labels.appearance'],
                    },
                },
                {
                    path: 'strategy',
                    name: 'settings.strategy',
                    component: () => import('@pages/settings/PageSettingsStrategy'),
                    meta: {
                        middleware: [AuthMiddleware, SectionMiddleware],
                        title: ['titles.settings', 'labels.strategy'],
                    },
                },
                {
                    path: 'email',
                    name: 'settings.email',
                    component: () => import('@pages/settings/PageSettingsEmails'),
                    meta: {
                        middleware: [AuthMiddleware, SectionMiddleware],
                        title: ['titles.settings', 'labels.email'],
                    },
                },
                {
                    path: 'sms',
                    name: 'settings.sms',
                    component: () => import('@pages/settings/PageSettingsSms'),
                    meta: {
                        middleware: [AuthMiddleware, SectionMiddleware],
                        title: ['titles.settings', 'labels.sms'],
                    },
                },
                {
                    path: 'ratings',
                    name: 'settings.ratings',
                    component: () => import('@pages/settings/PageSettingsRatings'),
                    meta: {
                        middleware: [AuthMiddleware, SectionMiddleware],
                        title: ['titles.settings', 'labels.ratings'],
                    },
                },
                {
                    path: 'members',
                    name: 'settings.members',
                    component: () => import('@pages/settings/PageSettingsMembers'),
                    meta: {
                        middleware: [AuthMiddleware, SectionMiddleware],
                        title: ['titles.settings', 'labels.members'],
                    },
                },
                {
                    path: 'signatures',
                    name: 'settings.signatures',
                    component: () => import('@pages/settings/PageSettingsSignature'),
                    meta: {
                        middleware: [AuthMiddleware, SectionMiddleware],
                        title: ['titles.settings', 'labels.signatures'],
                    },
                },
                {
                    path: 'sources',
                    name: 'settings.sources',
                    component: () => import('@pages/settings/PageSettingsSources'),
                    meta: {
                        middleware: [AuthMiddleware, SectionMiddleware],
                        title: ['titles.settings', 'labels.sources'],
                    },
                },
                {
                    path: 'tags',
                    name: 'settings.tags',
                    component: () => import('@pages/settings/PageSettingsTags'),
                    meta: {
                        middleware: [AuthMiddleware, SectionMiddleware],
                        title: ['titles.settings', 'labels.tags'],
                    },
                },
                {
                    path: 'showcase',
                    name: 'settings.showcase',
                    component: () => import('@pages/settings/PageSettingsShowcase'),
                    meta: {
                        middleware: [AuthMiddleware, SectionMiddleware],
                        title: ['titles.settings', 'labels.showcase'],
                    },
                },
                {
                    path: 'assistant',
                    redirect: { name: 'settings.ai-tools' },
                },
                {
                    path: 'ai-tools/reviews',
                    redirect: { name: 'settings.ai-tools.review-suggestions' },
                },
                {
                    path: 'ai-tools/tagging',
                    redirect: { name: 'settings.ai-tools.tags' },
                },
                {
                    path: 'ai-tools',
                    name: 'settings.ai-tools',
                    component: () => import('@pages/assistant'),
                    meta: {
                        middleware: [AuthMiddleware, SectionMiddleware],
                        title: ['titles.settings', 'labels.ai_tools'],
                    },
                },
                {
                    path: 'ai-tools/review-suggestions',
                    name: 'settings.ai-tools.review-suggestions',
                    component: () => import('@pages/assistant/PageAssistantReviews'),
                    meta: {
                        middleware: [AuthMiddleware, SectionMiddleware],
                        title: ['titles.settings', 'labels.ai_tools', 'titles.ai_review_suggestions'],
                    },
                },
                {
                    path: 'ai-tools/replies',
                    name: 'settings.ai-tools.replies',
                    component: () => import('@pages/assistant/PageAssistantReplies'),
                    meta: {
                        middleware: [AuthMiddleware, SectionMiddleware],
                        title: ['titles.settings', 'labels.ai_tools', 'titles.ai_replies'],
                    },
                },
                {
                    path: 'ai-tools/highlights',
                    name: 'settings.ai-tools.highlights',
                    component: () => import('@pages/assistant/PageAssistantHighlights'),
                    meta: {
                        middleware: [AuthMiddleware, SectionMiddleware],
                        title: ['titles.settings', 'labels.ai_tools', 'titles.ai_highlights'],
                    },
                },
                {
                    path: 'ai-tools/tags',
                    name: 'settings.ai-tools.tags',
                    component: () => import('@pages/assistant/PageAssistantTagging'),
                    meta: {
                        middleware: [AuthMiddleware, SectionMiddleware],
                        title: ['titles.settings', 'labels.ai_tools', 'titles.ai_tags'],
                    },
                },
                {
                    path: 'api',
                    name: 'settings.api',
                    component: () => import('@pages/settings/PageSettingsApi'),
                    meta: {
                        middleware: [AuthMiddleware, SectionMiddleware],
                        title: ['titles.settings', 'labels.api'],
                    }
                },
                {
                    path: 'mcp',
                    name: 'settings.mcp',
                    component: () => import('@pages/settings/PageSettingsMcp'),
                    meta: {
                        middleware: [AuthMiddleware, SectionMiddleware],
                        title: ['titles.settings', 'labels.mcp_server'],
                    }
                },
                {
                    path: 'integrations',
                    name: 'settings.integrations',
                    component: () => import('@pages/integrations'),
                    meta: {
                        middleware: [AuthMiddleware, SectionMiddleware],
                        title: ['titles.settings', 'labels.integrations'],
                    }
                },
                {
                    path: 'integrations/:slug/:callback?',
                    name: 'settings.integrations.show',
                    component: () => import('@pages/integrations/PageIntegration'),
                    meta: {
                        middleware: [AuthMiddleware, SectionMiddleware],
                        title: ['titles.settings', 'labels.integration'],
                    },
                    beforeEnter: (to, from, next) => {
                        if (['clicksend', 'simpletexting', 'textlink', 'twilio'].includes(to.params.slug)) {
                            window.router.push({ name: `settings.integrations.${to.params.slug}` });
                            return false;
                        }
                        return next();
                    },
                },
                {
                    path: 'integrations/twilio',
                    name: 'settings.integrations.twilio',
                    component: () => import('@pages/integrations/PageIntegrationTwilio'),
                    meta: {
                        middleware: [AuthMiddleware, SectionMiddleware],
                        title: ['titles.settings', 'labels.integration'],
                    }
                },
                {
                    path: 'integrations/clicksend',
                    name: 'settings.integrations.clicksend',
                    component: () => import('@pages/integrations/PageIntegrationClickSend'),
                    meta: {
                        middleware: [AuthMiddleware, SectionMiddleware],
                        title: ['titles.settings', 'labels.integration'],
                    }
                },
                {
                    path: 'integrations/simpletexting',
                    name: 'settings.integrations.simpletexting',
                    component: () => import('@pages/integrations/PageIntegrationSimpleTexting'),
                    meta: {
                        middleware: [AuthMiddleware, SectionMiddleware],
                        title: ['titles.settings', 'labels.integration'],
                    }
                },
                {
                    path: 'integrations/textlink',
                    name: 'settings.integrations.textlink',
                    component: () => import('@pages/integrations/PageIntegrationTextLink'),
                    meta: {
                        middleware: [AuthMiddleware, SectionMiddleware],
                        title: ['titles.settings', 'labels.integration'],
                    }
                },
            ],
        },
    ]
};